import { tv } from 'tailwind-variants';

import { baseCarouselStyles } from '../../lib/UiReviewLightboxBase.styles';

export const styles = tv({
  extend: baseCarouselStyles,
  slots: {
    base: 'flex items-center gap-2',
    viewport:
      'w-full max-sm:px-3 sm:w-[calc((var(--slide-size)+var(--slide-spacing))*6-var(--slide-spacing))]',
    slide: 'relative',
    image: 'object-cover',
    arrowButton: 'text-main h-6 p-0 max-sm:hidden'
  },
  variants: {
    hide: {
      true: {
        arrowButton: 'opacity-0'
      }
    }
  }
});
